import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import { ExtendedWorkFieldType } from '@Components/WorkItemV2/ExtendedWorkItem'

interface ExtendedWorkFieldsProps {
    fields?: ExtendedWorkFieldType[]
    defaultClassName: string
}

const ExtendedWorkFields = ({ fields, defaultClassName }: ExtendedWorkFieldsProps) => (
    <>
        {fields?.map((field) => (
            <div className={field.className || defaultClassName} key={field.title}>
                {field.tooltip ? (
                    <CustomToolTip key={field.title} title={field.title + ':'} info={field.tooltip ?? ''} />
                ) : (
                    <span>{field.title}:</span>
                )}
                <span>{field.value}</span>
            </div>
        ))}
    </>
)

export default ExtendedWorkFields
